export const resource = [
  {
    id: 3,
    title: '《2020年娃哈哈社交零售商联销体协议》',
  },
  {
    id: 4,
    title: '《招商简章与运行程序》',
  },
  {
    id: 5,
    title: '《商户办理“浙商创业贷”指引》',
  },
];
